import { useFlow } from "src/api/queries";
import { Spinner } from "src/base-components/Spinner";
import { flowFolderScope } from "src/hooks/useCapabilities/flowFolderScope";
import { Capabilities, FlowFolderScope } from "src/hooks/useCapabilities/types";
import { ProtectedRoute } from "src/router/ProtectedRoute";
import { FlowPageParams } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

type Props = {
  redirectPath?: string;
  canAccess: (capabilities: Capabilities, folder: FlowFolderScope) => boolean;
};

export const ProtectedFlowRoute: React.FC<Props> = ({
  redirectPath,
  canAccess,
}) => {
  const { flow_id: flowId } = useParamsDecode<FlowPageParams>();
  const { data: flow, isLoading } = useFlow(flowId);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <ProtectedRoute
      canAccess={(c) => canAccess(c, flowFolderScope(flow))}
      redirectPath={redirectPath}
    />
  );
};
